export const notificationUrl = (id) => `/reminders?reminder=${encodeURIComponent(id)}`;
export function pendingReminderDelivery(reminders, notified, now = Date.now()) {
  const due = reminders.filter((item) => !item.done && Number.isFinite(new Date(item.remind_at).getTime()) && new Date(item.remind_at).getTime() <= now && !notified.has(`${item.id}:${item.remind_at}`));
  const fresh = due.filter((item) => now - new Date(item.remind_at).getTime() <= 5 * 60 * 1000);
  return { due, fresh, older: due.filter((item) => !fresh.includes(item)) };
}
